module.exports = __webpack_public_path__ + "img/house_18.7e24e9aa.jpg";